<template>
    <ns-modal
        v-model="dialog"
        :title="txc.add_bank_account"
        :fullscreen="fullScreen"
        @input="closeDialog"
    >
        <server-error v-if="!!dialogError" :error="dialogError" />

        <v-form v-model="addBankAccountForm" @submit.prevent>
            <p class="mb-3">{{ txc.direct_deposit_explanation }}</p>
            <div data-test-id="directDepositNameAcct" class="field-label">{{ txc.direct_deposit_name_acct }}</div>
            <v-text-field data-test-id="name" v-model="name" readonly disabled />

            <div data-test-id="accountNumber" class="field-label">{{ txc.account_number }}</div>
            <v-text-field
                v-model="accountNumber"
                required
                pattern="[0-9]*"
                mask="#########"
                data-test-id="accountNumber"
            />

            <div data-test-id="bankName" class="field-label">Bank Name</div>
            <!-- <v-text-field v-model="bankName" required pattern="[0-9]*" mask="###-###" /> -->
            <v-select
                :items="bankNames"
                item-text="name"
                item-value="number"
                v-model="bankName"
                @change="getBranchList"
                return-object
                data-test-id="bankNames"
            />

            <div data-test-id="branchNames" class="field-label">Branch Names</div>
            <!-- <v-text-field v-model="bankName" required pattern="[0-9]*" mask="###-###" /> -->
            <v-select
                :items="bankBranches"
                item-text="name"
                item-value="number"
                v-model="bankBranch"
                return-object
                data-test-id="bankBranches"
            />

            <v-checkbox required :rules="[ruleSet.required]" class="mt-2">
                <template v-slot:label>
                    <span data-test-id="agreeToTerms" class="terms-text" v-html="ddAgreementTerms.terms_text"></span>
                </template>
            </v-checkbox>
        </v-form>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="primary-hit mb-2 fluid"
                        :disabled="
                            !addBankAccountForm ||
                                accountNumber.length < 8 ||
                                bankName.length < 1
                        "
                        @click="submitBankInfo"
                        data-test-id="save"
                    >
                        {{ txcg.save }}
                    </button>
                </v-flex>
                <v-spacer />
                <v-flex xs12>
                    <button
                        flat
                        outline
                        block
                        class="secondary-hit fluid"
                        @click="closeDialog"
                        data-test-id="cancel"
                    >
                        {{ txcg.cancel }}
                    </button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>
import * as ruleSet from '../../repositories/globalRules.js'
import profileUtils from '../../repositories/profileUtils.js'
import directDepositMapper from '../../helpers/forms/directDepositMapper.js'

import { ProfileService } from '@nuskin/ns-account'
import { mapActions, mapGetters } from 'vuex'

import { NsModal } from '@nuskin/design-components'
import ServerError from '../ServerError'

export default {
    components: {
        NsModal,
        ServerError
    },
    data() {
        return {
            ruleSet,
            dialog: true,
            dialogError: null,
            addBankAccountForm: false,
            name: '',
            bankName: '',
            bankNames: [],
            bankBranch: '',
            bankBranches: [],
            accountNumber: '',
            rules: {
                required: ruleSet.required
            }
        }
    },
    computed: {
        ...mapGetters({
            txc: 'translationsDirectDeposit',
            txcg: 'translationsGlobal',
            txce: 'translationsError',
            fullScreen: 'mobileView',
            localName: 'localName',
            account: 'account',
            country: 'country',
            translationsTerms: 'translationsTerms',
            ddAgreementTerms: 'directDepositAgreementTerms'
        })
    },
    methods: {
        ...mapActions(['setAccount']),
        closeDialog() {
            this.$emit('closeDialog')
            this.dialogError = null
        },
        submitBankInfo() {
            let payload = {
                name: this.name,
                accountNumber: this.accountNumber,
                bankName: this.bankName.name,
                bankNumber: this.bankName.number,
                branchNumber: this.bankBranch.number,
                country: 'NZ'
            }
            ProfileService.updateBankInfo(
                directDepositMapper.accountMapperCANZ(payload)
            )
                .then((response) => {
                    if (
                        response && response.data && 
                        response.data.accountNumber && 
                        response.data.messages === undefined
                    ) {
                        
                        this.$emit('bankAccountAdded')
                        /*profileUtils.publishAnalytics(
                            this.$analytics.category.deposits,
                            'GB_bank_account',
                            'added',
                            {
                                email: this.account.email
                            }
                        )*/
                        this.dialog = false;
                    } else if (
                        response &&
            response.data &&
            response.data.messages.length > 0
                    ) {
                        let error = response.data.messages[0].message
                        throw new Error(error)
                    } else {
                        throw new Error(this.txce.nonSpecific)
                    }
                })
                .catch((error) => {
                    this.dialogError = error
                })
        },
        getBankList() {
            let self = this
            ProfileService.getAvailableBanksForMarket('NZ').then(function (response) {
                self.bankNames = response
                self.bankNames.sort((a, b) => (a.name > b.name ? 1 : -1))
            })
        },
        getBranchList() {
            let self = this
            ProfileService.getAvailableBankBranches('NZ',this.bankName.number).then(function (response) {
                console.log(response.data.branches)
                self.bankBranches = response.data.branches
                self.bankBranches.sort((a, b) => (a.name > b.name ? 1 : -1))
            })
        }
    },
    created() {
        this.name = this.localName
        this.getBankList()
        profileUtils.publishAnalytics(
            this.$analytics.category.deposits,
            'GB_bank_account_dialog',
            'opened'
        )
    },
    destroyed() {
        profileUtils.publishAnalytics(
            this.$analytics.category.deposits,
            'GB_bank_account_dialog',
            'closed'
        )
    }
}
</script>
<style scoped lang="scss">
    @use "sass:map";
    @use "~@nuskin/ns-core-styles/src/scss/global.mixins";
    .terms-text {
       @include global.paragraph-m();
    }
</style>
